/**
 * Identificador aleatorio del navegador para el límite diario de la demo (24-10-2026).
 *
 * El límite por IP no servía con redes móviles que cambian de IP: un mismo grupo hizo 104 subidas desde 73 IPs.
 * Esto no identifica a nadie (es un número al azar que vive en este navegador) y solo viaja con la subida a la demo.
 * Si el almacenamiento está bloqueado devuelve null y queda solo el límite por IP.
 */
const KEY = "ws_demo_b";

export function demoBrowserId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id || !/^[A-Za-z0-9_-]{16,40}$/.test(id)) {
      const bytes = new Uint8Array(12);
      crypto.getRandomValues(bytes);
      id = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}
